/* globals translation */

// require('./mini-cart');
require('./quantity');
require('./wishlist');

jQuery(($) => {
  $('.accordion__content').hide(() => {
    $('.accordionHolder li').removeClass('active');
  });

  function accordions() {
    const accordionHolder = $('.accordionHolder');
    if (!accordionHolder.length) {
      return;
    }
    accordionHolder.each((index, accordion) => {
      const accordionChildren = $(accordion).children('.accordion');
      const allAccordionContent = $(accordion).find('.accordion__content');

      accordionChildren.each((i, thisAccordion) => {
        const titleAccordion = $(thisAccordion).find('.accordion__title');
        const contentAccordion = $(thisAccordion).find('.accordion__content');

        titleAccordion.on('click', () => {
          if ($(thisAccordion).hasClass('open')) {
            $(thisAccordion).removeClass('open');
          } else {
            accordionChildren.stop().removeClass('open');
            $(thisAccordion).addClass('open');
          }
          allAccordionContent.stop().slideUp();
          contentAccordion.stop().slideToggle();
        });
      });
    });
  }

  accordions();
});


jQuery(($) => {
  $('.child-categories').parent('li').addClass('parent-cat');
  $('.mer-woo-product-documents-list').on('click', (e) => {
    e.stopPropagation();
  });
  if (!$.trim($('.woocommerce-Tabs-panel--technical_documentation').html()).length) {
    $('.technical_documentation_tab').hide();
    $('.woocommerce-Tabs-panel--technical_documentation').hide();
  }
});

jQuery(($) => {
  const categoryTitle = $('ul.parent-categories li.parent-cat > a span.icon-holder');
  categoryTitle.each(function filterTitleEach() {
    if ($(this).parent().parent().find('.chosen').length > 0) {
      $(this).addClass('active');
      $(this).parent().parent().find('ul.child-categories')
        .show();
    }
    $(this).on('click', (e) => {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().parent().find('ul.child-categories')
        .slideToggle();
    });
  });
});

jQuery(($) => {
  const fdvDiv = $('.generated-fdv-pdfs');


  $('.variations_form').on('found_variation', (e, variation) => {
    if (variation && variation.pdf_generated) {
      fdvDiv.html(`<div class="fdv-wrapper">${variation.pdf_generated}</div>`);
    }
  });

  $('.variations_form').on('woocommerce_variation_select_change', (e) => {
    // Fires whenever variation selects are changed
    let varId = 0;
    // Add link to documentation
    if (fdvDiv.length > 0) {
      fdvDiv.html(fdvDiv.data('main-link'));
    }
    function numberWithSpaces(x) {
      const parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join('.');
    }

    $('input.variation_id').change(() => {
      if ($('input.variation_id').val() !== '') {
        varId = parseInt($('input.variation_id').val(), 10);

        const arrChilds = $('.variations_form').data('product_variations');

        for (let i = 0; i < arrChilds.length; i += 1) {
          if (arrChilds[i].variation_id === varId) {
            // Add link to documentation
            if (arrChilds[i].pdf_generated && fdvDiv.length > 0) {
              fdvDiv.html(`<div class="fdv-wrapper">${arrChilds[i].pdf_generated}</div>`);
            }
            $('.entry-summary > p.price').hide();
            const $currency = $('.variation-meta').data('currency');
            const $price = Math.round(arrChilds[i].display_price);
            const $regularPrice = Math.round(arrChilds[i].display_regular_price);
            if ($('body').hasClass('logged-in')) {
              $('.variation-meta').html(`<p class="price"><small>Deres pris </small><span class="deres">${$currency} ${numberWithSpaces($price)},- </span><br/><small class="list">Listepris </small><span class="liste">${$currency} ${numberWithSpaces($regularPrice)},- </span></p>`);
            } else {
              $('.variation-meta').html(`<p class="price"><small class="list">Listepris </small><span class="liste">${$currency} ${numberWithSpaces($price)},- </span></p>`);
            }
            break;
          }
        }
      } else {
        $('.entry-summary > p.price').show();
        $('.variation-meta > p.price').hide();
      }
    });
  });

  $('.variations_form').trigger('woocommerce_variation_select_change');
  $('input.variation_id').trigger('change');
});

jQuery(($) => {
  const activeurl = window.location;
  $(`ul.parent-categories li.category a[href="${activeurl}"]`).addClass('active');
});

jQuery(($) => {
  $(document).on('click', 'button.menu-toggle', (e) => {
    $('.site-header > .col-full').toggleClass('mobile-menu-toggled');
  });
});

jQuery(($) => {
  const link = $('.primary-navigation .menu > li >  a');
  // link.on('mouseover', (e) => {
  //   if (e.target.parentNode.classList.contains('menu-item-has-children')) {
  //     e.preventDefault();
  //     e.target.parentNode.classList.add('active');
  //   }
  //   if (e.target.parentNode.getElementsByClassName('sub-menu')[0]) {
  //     e.preventDefault();
  //     e.target.parentNode.classList.add('sub-menu-active');
  //   }
  // });
  // link.on('mouseout', (e) => {
  //   if (e.target.parentNode.classList.contains('menu-item-has-children')) {
  //     e.preventDefault();
  //     e.target.parentNode.classList.remove('active');
  //   }
  //   if (e.target.parentNode.getElementsByClassName('sub-menu')[0]) {
  //     e.preventDefault();
  //     e.target.parentNode.classList.remove('sub-menu-active');s
  //   }
  // });
  $('.maksimer-navigation ul li.menu-item-has-children > a').after(`<span class="toggle-sub"><img src="${translation.templateUrl}/assets/images/plus.svg"/></span>`);
  $('.maksimer-navigation ul li.menu-item-has-children > .toggle-sub').each(function () {
    $(this).on('click', () => {
      $(this).siblings('.sub-menu').toggleClass('opened');
    });
  });
  $('#categories-sidebar .categories-sidebar-title > img').on('click', function () {
    $(this).parent().next('ul').slideToggle();
  });
});

jQuery(($) => {
  $('.archive .woocommerce-breadcrumb').prepend(`<div class="toggle-sidebar"><img src="${translation.templateUrl}/assets/images/hamburger.svg" alt="toggle"/></div>`);
  $(document).on('click', '.toggle-sidebar img', (e) => {
    $('.categories-wrapper').toggleClass('sidebar-toggled');
  });
});
jQuery(($) => {
  $('body.tax-product_cat .woocommerce-breadcrumb .toggle-sidebar').prepend(`<a href="${translation.shopUrl}" class="shop-link" >Produkter</a><span class="breadcrumb-separator"> / </span>`);
  $('body.single-product .woocommerce-breadcrumb').prepend(`<a href="${translation.shopUrl}" class="shop-link" >Produkter</a><span class="breadcrumb-separatorr"> / </span>`);
});

jQuery(($) => {
  const expiredLabel = $('.flex-viewport figure .expired-label');
  const nyheterLabel = $('.flex-viewport figure .nyheter-label');
  if (expiredLabel) {
    expiredLabel.detach().appendTo('.flex-viewport');
  }
  if (nyheterLabel) {
    nyheterLabel.detach().appendTo('.flex-viewport');
  }
});
jQuery(($) => {
  $('body').on('keyup change', '.results-container .result-row-product .quantity input', function (e) {
    const button = $(this).parents('.result-row-product').find('a.button');
    const min = $(this).attr('min');
    if (!$(this).val()) {
      button.addClass('disabled');
    } else {
      button.removeClass('disabled');
    }
    if (typeof this.checkValidity === 'function' && this.checkValidity()) {
      button.attr('data-quantity', $(this).val());
    } else {
      $(this).val(min);
      button.attr('data-quantity', min);
    }
  });
});

const maksimer = {
  changeSearhInputPlaceholder: () => {
    const searchInputs = document.querySelectorAll(
      'form.search-form label > input.search-field',
    );
    if (searchInputs) {
      searchInputs.forEach((searchInput) => {
        searchInput.placeholder = 'Søk produkter....';
      });
    }
  },
};
maksimer.changeSearhInputPlaceholder();

jQuery(($) => {
  $('a.toggle-mini-wishlist').on('click', (e) => {
    e.preventDefault();
    $('.mini-dropdown-list').toggleClass('visible');
  });
  $('.close-mini-wishlist-modal').on('click', (e) => {
    e.preventDefault();
    $('.mini-dropdown-list').removeClass('visible');
  });
  $('body.single-product:not(.logged-in ) .krokedil-wishlist svg').click(() => {
    setTimeout(
      () => {
        window.location.reload();
      }, 2000,
    );
  });
});

jQuery(($) => {
  $('ul.login-dropdown > li').hover(() => {
    $('ul.login-children').addClass('opened');
  },
  () => {
    $('ul.login-children').removeClass('opened');
  });
});

jQuery(($) => {
  $('a.toggle-search').on('click', (e) => {
    $('form.search-form').toggleClass('visible');
    document.querySelector('form.search-form input.search-field').select();
  });
});

jQuery(($) => {
  $('ul.login-dropdown > li').hover(() => {
    $('ul.login-children').addClass('opened');
  },
  () => {
    $('ul.login-children').removeClass('opened');
  });
});

jQuery(($) => {
  $('button.log_in').on('click', (e) => {
    e.preventDefault();
    $('body.single-product .login-form').toggleClass('opened');
  });
  $('.close-login').on('click', (e) => {
    $('body.single-product .login-form').removeClass('opened');
  });
  $('body.single-product:not(.logged-in)  .single_variation_wrap').on('show_variation', (event, variation) => {
    $('body.single-product:not(.logged-in) .woocommerce-variation-add-to-cart .log_in.hidden').removeClass('hidden');
  });
});

jQuery(($) => {
  $('form.search-form').on('click', (e) => {
    e.stopPropagation();
  });
});

jQuery(($) => {
  $('button:contains(Update Wishlist)').html('Oppdater favorittliste');
  $('table.tinvwl-table-manage-list th.product-quantity').html('Antall');
  $('.tinvwl_add_to_select_wishlist .tinv-modal-inner > label').html('Velg ønskeliste');
  $('.estimate-dialogbox.tinv-modal .tinv-table form textarea').attr('placeholder', 'Tilleggs notat...');
  $('.estimate-dialogbox.tinv-modal .tinv-table form button').html('Send forespørsel');
  $('.estimate-dialogbox.tinv-modal .tinv-table form > h2').html('Kontakt detaljer');
  $('.estimate-dialogbox.tinv-modal .tinv-table form input.tinv-text-input.tinv-first').attr('placeholder', 'Ditt navn (kreves)');
  $('.estimate-dialogbox.tinv-modal .tinv-table form input.tinv-text-input:not(.tinv-first)').attr('placeholder', 'Din epost (kreves)');
  const wishlistEstimateWrap = document.querySelector('.tinv-wishlist .tinvwl-estimate-wrap > a');
  if (wishlistEstimateWrap) wishlistEstimateWrap.childNodes[1].nodeValue = 'Be om et tilbud';
});

jQuery(($) => {
  $('.variations_form').on('show_variation', () => {
    const stockStatus = $('.woocommerce-variation-availability p.stock');
    const stockStatusText = stockStatus.text();
    if (stockStatus) {
      $('.bottom-info span p').text(stockStatusText);
      if (stockStatusText === 'Bestillingsvare') {
        $('body.single.single-product .product-type-variable .bottom-info').css('display', 'flex');
        $('.bottom-info p.delivery span').text('1-3 uker');
      } else if (stockStatusText === 'Lagervare') {
        $('body.single.single-product .product-type-variable .bottom-info').css('display', 'flex');
        $('.bottom-info p.delivery span').text('1-3 virkedager');
      }
    }
  });
});

jQuery(($) => {
  $(document).on('click', '.different-shipping-address input', (e) => {
    $('.levering-holder').toggleClass('show');
  });
});
